import { createFileRoute } from '@tanstack/react-router'
import { LoanAppForm, CobrandedLayout } from 'merchant-components'

export const Route = createFileRoute('/application/$id/apply')({
  component: () => <CobrandedLayout outlet={<LoanAppForm />} />,
})

